export default __webpack_public_path__ + "static/andre-cv-369faf5a2f586c08e768d95d1258a907.png";